'use strict';

/**
 * Filter
 *
 * @author Mathias Hayoz <mathias.hayoz@namics.com>
 */
T.Module.Filter = T.createModule({

	_selectors: {
		form: '[data-js-m-filter__form]',
		picker: '[data-js-m-filter__picker]',
		item: '[data-js-m-filter__item]',
		dropdown: '[data-js-m-filter-dropdown__input]',
		textToggle: '[data-js-m-filter__text-toggle]',
		textInputField: '[data-js-m-filter__text-input-field]',
		textInputClose: '[data-js-m-filter__text-input-close]',
		querySubmit: '[data-js-m-filter__query-icon]',
		locationFinderWrapperDiv: '.o-location-finder__filter'
	},

	_stateClasses: {
		open: 'state-open',
		searching: 'state-searching',
		notSearching: 'state-not-searching'
	},

	_eventNames: {
		// This event only applies to the filter as you type text input.
		filterChange: 'm-filter-change',
		searchClosed: 'm-filter-search-closed'
	},

	start: function start(resolve) {
		this.$ctx = $(this._ctx);

		// References
		this.$form = this.$ctx.find(this._selectors.form);
		this.$picker = this.$ctx.find(this._selectors.picker);
		this.$items = this.$ctx.find(this._selectors.item);
		this.$textToggle = this.$ctx.find(this._selectors.textToggle);
		this.$textInputField = this.$ctx.find(this._selectors.textInputField);
		this.$textInputClose = this.$ctx.find(this._selectors.textInputClose);
		this.$filterDropdowns = this.$items.find(this._selectors.dropdown);
		this.$querySubmit = this.$ctx.find(this._selectors.querySubmit);

		// Component Event Binding
		this.$picker.click(this.$onPickerClick.bind(this));
		this.$textToggle.click(this.$onTextToggleClick.bind(this));
		this.$textInputClose.click(this.$onTextToggleClick.bind(this));
		this.$filterDropdowns.on('change', this.$onDropDownChange.bind(this));

		this.$textInputField.on('change paste keyup', this.$onInputChange.bind(this));
		this.$textInputField.on('keypress', this.$onInputKeypress.bind(this));

		// submit button is only visible if there is an active search query on page load
		this.$querySubmit.click(this.$onFullTextSearch.bind(this));
		this.$form.on('submit', this.$onFormSubmit.bind(this));

		// Data
		this.submitEventName = this.$form.data('submit-event');

		resolve();
	},


	/**
  * Event when the user clicks on show / hide filters toggle on small screen
  *
  * @returns {void}
  */
	$onPickerClick: function $onPickerClick() {
		this.$ctx.toggleClass(this._stateClasses.open);
	},


	/**
  * Event when the user clicks on the element to show / hide the free text search field
  *
  * @returns {void}
  */
	$onTextToggleClick: function $onTextToggleClick() {
		if (this.$ctx.hasClass(this._stateClasses.searching)) {
			this.$textInputField.val('');
			this._events.emit(this._eventNames.searchClosed);
			this.$ctx.addClass(this._stateClasses.notSearching);
		} else {
			this.$ctx.removeClass(this._stateClasses.notSearching);
		}

		this.$textInputField.focus();
		this.$ctx.toggleClass(this._stateClasses.searching);
	},


	/**
  * Event when the value of the free text search field changes
  *
  * @param {Event} event The change / keyup event
  * @returns {void}
  */
	$onInputChange: function $onInputChange(event) {
		var value = event.target.value;
		this._events.emit(this._eventNames.filterChange, value);
	},


	/**
  * Event when the a keypress happens in the free text search field
  *
  * @param {Event} event The keypress event
  * @returns {void}
  */
	$onInputKeypress: function $onInputKeypress(event) {
		// if the key was enter and we are within the location finder, we prevent submitting the form
		if (event.which === 13 && this.$ctx.closest(this._selectors.locationFinderWrapperDiv).length > 0) {
			event.preventDefault();
		}
	},


	/**
  * Event when the form gets submitted, prevent submit if a special event is defined and fire event in that case
  *
  * @param {Event} event The submit event
  * @returns {void}
  */
	$onFormSubmit: function $onFormSubmit(event) {
		// If defined: Emit Event
		if (this.submitEventName) {
			// Stop submitting form
			event.preventDefault();

			var $elm = $(event.currentTarget);
			var formData = $elm.serialize();
			this._events.emit(this.submitEventName, formData);
		} else {
			// Otherwise: Submit as form
		}
	},


	/**
  * Event when a fulltext search get's submitted
  *
  * @returns {void}
  */
	$onFullTextSearch: function $onFullTextSearch() {
		this.$form.submit();
	},


	/**
  * Event when the filter dropdown get's changed by the user, trigger a form submit
  *
  * @returns {void}
  */
	$onDropDownChange: function $onDropDownChange() {
		this.$form.submit();
	}
});